module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "calibre_"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('a'), _vm._v("Also by Wei Wu Wei")])]), _c('div', {
    staticClass: "calibre_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INGERS")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OINTING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWARDS THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OON")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SK THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WAKENED")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDAGE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PEN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECRET")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTH")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSTHUMOUS")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IECES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NWORLDLY")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f64f216c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_002.vue
// module id = 66
// module chunks = 0